import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';

// Routes
import routes from './routes';

// Redux
import actions from './actions';
import store from './store';

// Styles
import './styles/index.scss';

// Hydrate Redux Store
import projects from './fixtures/projects';
store.dispatch(
  actions.setProjects(projects)
);

/**
  Client-side entry point
  ---
  ./src/index.js

  In this class we:
  - call `ReactDOM.render()` on the client
  - allow client-side routing with React Router
  - pass in our Redux data store
*/

// Start loading
const root = document.getElementById('root');
root.innerHTML = 'Loading...';

const Client = () => (
  <Provider store={store}>
    <Router history={browserHistory} routes={routes} />
  </Provider>
);

// Render Client in #root
ReactDOM.render(<Client />, root);



// WEBPACK FOOTER //
// ./src/index.js